import { render, staticRenderFns } from "./ManageCompetitions.vue?vue&type=template&id=1fb995a5&"
import script from "./ManageCompetitions.vue?vue&type=script&lang=js&"
export * from "./ManageCompetitions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports